const messages = {
  es: {
    translations: {
      common: {
        yes: "Sí",
        no: "No",
        tags: "Etiquetas",
        noTags: "Sin Etiquetas",
      },
      signup: {
        title: "Registro",
        toasts: {
          success:
            "El usuario ha sido creado satisfactoriamente! Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "Whatsapp (COD + NUMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¡Ya tienes una cuenta! ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduzca sus datos para acceder a su cuenta",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¡No tienes cuenta! ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "Inicio de sesión éxitoso!",
        },
        dueDate: {
          expiration: "La suscripción caducará en",
          days: "Dias!",
          day: "Dia!",
          expirationToday: "¡Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          groups: "Grupos",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidos",
          totalSentMessages: "Total de Mensajes Enviados",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atencion por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponible hasta",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets esperando evaluacion",
          callsWithoutRating: "Ticket sin evaluacion",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Detractores",
        },
      },
      reports: {
        title: "Reporte de Encuestas Realizadas",
        operator: "Agente",
        period: "Periodo",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Reportes",
        calls: "Atenciones",
        search: "Encuestas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          lastMessageAt: "Fecha/Hora Ult. Msj",
          contact: "Cliente",
          number: "Número",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando reporte compactado, por favor espere.",
          errorToast: "Error al generar reporte",
          back: "Volver",
          groupServiceReport: "Reporte de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualizacion",
          agent: "Agente",
          agentClosed: "Agente (cerro)",
          waitingAssistance: "Esperando atencion",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidad",
          percentage: "Porcentaje",
          title: "Reporte de Encuestas Realizadas",
          activeSearch: "Encuesta activa",
          inactiveSearch: "Encuesta inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando reporte compactado, por favor espere.",
          title: "Reporte de Duracion de la Atención",
          startService: "Inicio de la Atención",
          lastUpdated: "Ultima actualizacion",
          lastAgent: "Ultimo agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Reporte de Duracion de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duracion de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando reporte compactado, por favor espere.",
          title: "Reporte de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            connectionNumber: "Número Conexión",
            scheduledDate: "Fecha programada",
            contact: "Contacto",
            contactNumber: "Número",
            tags: "Tags",
            kanban: "Kanban",
            user: "Usuario",
            queue: "Fila",
            status: "Estado",
            lastMessage: "Ultimo Mensaje",
            lastMessageDate: "Fecha Ult. Mensaje",
            lastMessageTime: "Hora Ult. Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
            valorVenda: "Valor de la Venta",
            motivoNaoVenda: "Motivo de la No Venta",
            finalizadoComVenda: "Finalizado con Venta",
          },
        },
        pdf: {
          title: "Relacion de Atenciones Realizadas",
          exportTitle: "Relacion de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos a Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importacion",
          closed: "Cerrar",
          import: "Seleccione el archivo de Excel para importar los Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones seran reiniciadas!",
        callSupport: "Soporte",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        subTitle:
          " Conecte sus canales de atención para recibir mensajes e iniciar conversaciones con sus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        launcher: {
          title: "Elegir canal",
          description:
            "Selecciona el canal que quieres conectar para esta empresa. El flujo QR sigue igual y los canales Meta usan su configuracion actual.",
          whatsappQrTitle: "WhatsApp QR",
          whatsappQrDescription:
            "Mantiene el flujo actual con QR y sesión del celular usando Baileys. No cambia nada de lo que hoy ya funciona.",
          whatsappQrTag: "Sesión QR",
          whatsappApiTitle: "WhatsApp API",
          whatsappApiDescription:
            "Crea una conexion oficial de Meta para automatizaciones, plantillas, webhooks y operacion por Cloud API.",
          whatsappApiTag: "Oficial",
          whatsappCoexistenceTitle: "YCloud coexistente",
          whatsappCoexistenceDescription:
            "Usa el mismo numero (WhatsApp Business App + API) por YCloud. Recibe mensajes por webhook y guarda los mensajes del celular (echoes), sin reemplazar el QR.",
          whatsappCoexistenceTag: "YCloud",
          facebookTitle: "Facebook",
          facebookDescription:
            "Conecta paginas y mensajes de Facebook con el login actual de Meta para esta empresa.",
          instagramTitle: "Instagram",
          instagramDescription:
            "Conecta Instagram Direct y comentarios con el login actual de Meta para esta empresa.",
          metaLoginTag: "Meta Login",
        },
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¡Seguro! Todos los tickets importados serán cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¡Estás seguro! Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¡Estás seguro! Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importacion",
          importing: "Importando Mensajes del WhatsApp",
          newQr: "Nuevo QR CODE",
          processed: "Procesado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Procesado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegurese de que su telefono celular este conectado a Internet y vuelva a intentarlo o solicite un nuevo codigo QR",
          },
          qrcode: {
            title: "Esperando la lectura del codigo QR",
            content:
              "Haga clic en el boton 'CODIGO QR' y lea el Codigo QR con su telefono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdio la conexion con el telefono celular",
            content:
              "Asegurese de que su telefono celular este conectado a Internet y que WhatsApp este abierto, o haga clic en el boton 'Desconectar' para obtener un nuevo codigo QR",
          },
        },
        table: {
          channel: "Canal",
          color: "Color",
          id: "ID",
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Ultima Actualizacion",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          receiveComments: "Recibir Comentarios",
        },
        receiveComments: {
          enabled: "Recepción de comentarios habilitada",
          disabled: "Recepción de comentarios deshabilitada",
          tooltip: {
            enabled: "Los comentarios se estan recibiendo. Haga clic para deshabilitar.",
            disabled: "Los comentarios no se estan recibiendo. Haga clic para habilitar.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Histórico",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "inició la atención.",
          access: "accedió al ticket.",
          transfered: "transfirió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regreso a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          group: "Permitir grupos",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCION: Guardando, su conexion sera cerrada, usted tendra que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad maxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envio del chatbot",
          expiresTicket: "Cerrar chats abiertos despues de *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad maxima de veces que la evaluacion sera enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atencion",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusion",
          lgpdLinkPrivacy: "Link para politicas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmacion del contacto",
          ratingMessage: "Mensaje de evaluacion - Rango de 0 a 10",
          token: "Token para integracion externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo en minutos para el envio del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el ultimo mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividad",
          prompt: "Prompt",
          triggerIntegrationOnClose:
            "Integración de activadores al cerrar un ticket",
          enableIntegration: "Activador Integración",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          collectiveVacationStart: "Fecha de inicio",
          collectiveVacationEnd: "Fecha final",
          officialSetupTitle: "WhatsApp Oficial",
          officialBadge: "Meta Cloud API",
          officialSetupDescription:
            "Use este canal para conectar números de la API oficial de Meta, incluidos números con coexistencia. Su conexión QR actual sigue separada y no se modifica.",
          officialCloudTitle: "Cloud API",
          officialCloudDescription:
            "Completa los identificadores y el token del numero oficial para activar envio, recepcion y automatizaciones por el canal de Meta.",
          officialCoexistenceTitle: "Coexistencia",
          officialCoexistenceDescription:
            "Si el número ya está habilitado con coexistencia en Meta, puede operar aquí por el canal oficial sin reemplazar su conexión por QR.",
          officialWebhook: "Webhook oficial",
          officialSetupHelper:
            "Los campos de abajo pertenecen al numero oficial configurado en Meta. Este flujo mantiene intacto el QR/Baileys y usa el canal oficial solo en esta conexion.",
          isOficial: "Oficial",
          phone_number_id: "ID del numero de telefono",
          waba_id: "WABA ID",
          send_token: "Token de envio",
          business_id: "ID del Administrador Comercial",
          phone_number: "Número de telefono",
          ycloudApiKey: "API Key de YCloud",
          ycloudApiKey: "YCloud API Key",
          ycloudWebhookSecret: "YCloud Webhook Secret (whsec_...)",
          ycloudWebhookUrl: "YCloud Webhook URL",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Ademas del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluacion para el NPS.",
      },
      qrCode: {
        message: "Lee el codigo QR para empezar la sesión.",
        waiting: "Generando el QR...",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "La conversacion fluye",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¡Está seguro que desea borrar este contacto! Todos los tickets relacionados se perderán.",
          blockContact: "¡Estás seguro que quieres bloquear este contacto!",
          unblockContact:
            "¡Estás seguro que quieres desbloquear este contacto!",
          importMessage: "¡Quieres importar todos los contactos del teléfono!",
          importChat: "Importar Conversaciones",
          wantImport:
            "¡Quieres importar todas las conversaciones del teléfono!",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          wallet: "Cartera",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
        },
        wallet: {
          unassigned: "No asignado",
          userNotFound: "Usuario no encontrado"
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Maximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Maximo de mensajes del Histórico",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
        },
        success: "Prompt guardado",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        noPermission:
          "Esta empresa no tiene permiso para acceder a esta pagina. Te estamos redirigiendo.",
        table: {
          name: "Nombre",
          queue: "Sector/Fila",
          max_tokens: "Maximo Tokens Respuestas",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Estas seguro! Esta accion no se puede revertir!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Terminos P.P. aceptados en:",
          whatsapp: "Conexión origen:",
          assignWallet: "Cartera del cliente",
          userNoQueues: "El usuario no tiene filas asociadas",
          selectUserFirst: "Seleccione un usuario primero",
          noActiveFloup: "Ningún Floup activo",
          noFloupHelper: "Este contacto no esta en ningun Floup en este momento",
          nextExecution: "Próxima ejecución:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
        },
        buttons: {
          addExtraInfo: "Agregar informacion",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminacion",
        confirmDeleteMessage:
          "¡Está seguro de que desea eliminar este contacto de la billetera!",
        deleteSuccess: "Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "Billetera actualizada exitosamente!",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atencion",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¡Está seguro! Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotacion",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atencion",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opcion, se elegira automaticamente, lo que hara que el bot responda con el mensaje de la opcion y avance.",
          selectOption: "Seleccione una opcion",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integración",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del termino",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del termino",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversacion",
          typebotDelayMessage: "Intervalo entre mensajes (ms)",
          typebotKeywordFinish: "Palabra para finalizar la conversacion",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversacion",
          typebotUnknownMessage: "Mensaje de opcion invalida",
          flowBuilderEnabled: "Activar Flow Builder junto con esta integracion",
          flowBuilderEnabledHint: "Permite usar etiquetas, kanban y palabras clave del Flow Builder",
          allowFlowbuilder: "Permitir FlowBuilder en paralelo",
          flowId: "Flujo",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "Integración testada con éxito!",
          addSuccess: "Integración agregada con éxito!",
          editSuccess: "Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Eliminar Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión por Defecto",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estandar",
          defaultTheme: "Tema Estandar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversacion de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
        },
        tabs: {
          general: "General",
          permissions: "Permisos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electronico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envio",
          assinar: "Firmar mensaje",
          reminderTitle: "Recordatorio (Opciónal)",
          reminderDescription:
            "Define una fecha de recordatorio. El mensaje se enviara en ese horario en lugar del horario original de la programacion.",
          reminderDate: "Fecha del recordatorio",
          reminderMessageInfo:
            "El mensaje del recordatorio sera el mismo del mensaje programado.",
          quickMessagePlaceholder: "Escriba para buscar respuestas rapidas...",
          noQuickMessagesFound: "No se encontraron respuestas rapidas",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nuevo carril",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar carril",
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo en minutos para saltar al siguiente carril",
          nextLaneId: "Siguiente carril",
          greetingMessageLane: "Mensaje de bienvenida del carril",
          mediaFiles: "Archivos Multimedia",
          rollbackLaneId: "Carril de retorno al retomar atencion",
          integrationId: "Integración FlowBuilder",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Carril guardado satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menu de evaluacion",
          edit: "Editar menu de evaluacion",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          extraName: "Nombre de la opcion",
          extraValue: "Valor de la opcion",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            " ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Nuevo grupo",
        modal: {
          conversation: "Inicio",
          title: "Titulo",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Eliminar Chat",
          message: "Esta accion no se puede revertir, confirmar!",
        },
      },
      ticketsManager: {
        questionCloseTicket: "Quieres cerrar todos los tickets!",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Cerrar todos los tickets!",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
          all: "Todos",
          searchOnMessages: "Marcar para buscar tambien en el contenido de los mensajes (mas lento)",
          oldFirst: "Antiguos primero",
          newFirst: "Recientes primero",
          unread: "No leidos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Entradas por pagina",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observacion - los mensajes internos, no seran visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo grupo",
        modal: {
          conversation: "Inicio",
          title: "Titulo",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Eliminar Chat",
          message: "Esta accion no se puede revertir, confirmar!",
        },
      },
      ticketsList: {
        called: "Tickets",
        today: "Hoy",
        missedCall: "Llamada de voz/video perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Atendiendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aca!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o termino de busqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar a PDF",
          exportAsText: "Exportar a texto (.txt)",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Panel de Control",
          connections: "Conexiones",
          chatsTempoReal: "Atención en Tiempo Real",
          tickets: "Inbox",
          quickMessages: "Respuestas Rapidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Filas",
          tags: "Tags",
          administration: "Admin",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuración",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Agendamiento",
          campaigns: "Difusiones",
          annoucements: "Boletines",
          chats: "Chats",
          automations: "Automatiza",
          birthdayMenu: "Cumpleaños",
          files: "Archivos",
          callHistorical: "Llamadas",
          prompts: "Talk.Ai",
          allConnections: "Admin Conexiones",
          queueIntegration: "Integraciones",
          kanban: "Kanban",
          management: "Gestión",
          reports: "Reportes",
          financeiro: "Finanzas"
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguire apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token invalido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localizacion",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Actualizar",
          closeDrawer: "Cerrar menú lateral",
          changeLanguage: "Cambiar idioma",
          toggleTheme: "Cambiar tema",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Espanol",
        es: "Espanol",
        en: "English",
        tr: "Turkce",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentacion para envio de mensajes",
          methods: {
            title: "Metodos de Envio",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Multimedia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexion que enviara los mensajes. <br />Para registrarse, acceda al menu 'Conexiones', haga clic en el boton de edicion de la conexion e inserte el token en el campo correspondiente.",
            comments2:
              "El numero de envio no debe tener mascara ni caracteres especiales y debe constar de:",
            codeCountry: "Codigo del Pais",
            code: "Codigo del Estado",
            number: "Número",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuacion se muestra la lista de informacion necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensajes de Multimedia",
            instructions:
              "A continuacion se muestra la lista de informacion necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
        recentMessages: "Mensajes",
      },
      triggerFlowModal: {
        title: "Disparar Flujo",
        description:
          "Selecciona un flujo para ejecutar en este ticket. El ticket pasará temporalmente a estado chatbot.",
        selectFlow: "Elegir flujo",
        searchPlaceholder: "Buscar flujo por nombre o ID...",
        noResults: "No se encontraron flujos con ese criterio.",
        selectedFlow: "Flujo seleccionado",
        flowId: "ID del flujo",
        noFlows: "No hay flujos activos disponibles",
        cancel: "Cancelar",
        trigger: "Disparar Flujo",
        triggering: "Disparando...",
        success: "Flujo disparado correctamente",
        error: "Error al disparar flujo",
        selectWarning: "Por favor selecciona un flujo para disparar.",
        countAvailable: "flujos activos disponibles",
        doubleClickHint: "Clic para seleccionar o doble clic para disparar",
      },
      quickMessages: {
        title: "Respuestas Rapidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin anexo",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta accion no se puede revertir. Continuar!",
        },
        selectMessage: "Seleccionar Respuesta Rapida",
        hasMedia: "Con medios",
        global: "Global",
        noResultsFound: "No se encontró ninguna respuesta rápida para su búsqueda",
        noQuickMessages: "No hay respuestas rapidas disponibles",
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo eliminado satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rapido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Agregar",
          edit: "Editar",
          general: "General",
          visao: "Permitir vision",
          tag: "Etiqueta a aplicar",
          noTag: "Sin etiqueta",
          status: "Estado",
          language: "Idioma",
          category: "Categoria",
          metaID: "Meta ID",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          media: "Medios",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta accion no se puede revertir.",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electronico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electronico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta accion no se puede revertir.",
          importMessage: "Quieres importar esta plantilla! ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Busqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Lista de contactos",
          settings: "Ajustes",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor despues de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de disparo mayor",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Desactivada",
          enabled: "Activada",
          status: "Estado",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
          recurrence: "Recurrencia",
          nextScheduledAt: "Próxima ejecución",
          recurrenceFinished: "Recurrencia finalizada",
        },
        dialog: {
          new: "Nueva Campana",
          update: "Editar Campana",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de confirmacion 1",
            confirmationMessage2: "Mensaje de confirmacion 2",
            confirmationMessage3: "Mensaje de confirmacion 3",
            confirmationMessage4: "Mensaje de confirmacion 4",
            confirmationMessage5: "Mensaje de confirmacion 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programa",
            confirmation: "Confirmacion",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Estado del ticket",
            openTicketStatus: "Abierto",
            pendingTicketStatus: "Pendiente",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
            changeTag: "Cambiar a etiqueta",
            changeKanban: "Mover a Kanban",
            changeQueue: "Mover a Fila",
            none: "Ninguno",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar envios",
            restart: "Reiniciar envios",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta accion no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campana cancelada",
          restart: "Campana reiniciada",
          deleted: "Registro eliminado",
        },
        noPermission: "Esta empresa no tiene permiso para acceder a esta pagina. Te estamos redireccionando.",
        recurrenceStopped: "Recurrencia detenida con éxito.",
        status: {
          inactive: "Inactiva",
          scheduled: "Programada",
          inProgress: "En Proceso",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        recurrence: {
          perMinute: "Por Minuto",
          perHour: "Por Hora",
          daily: "Diario",
          weekly: "Semanal",
          biweekly: "Quincenal",
          monthly: "Mensual",
          yearly: "Anual",
        },
        recurrenceConfig: "Configuración de recurrencia",
        enableRecurrence: "Habilitar recurrencia",
        recurrenceType: "Tipo de Recurrencia",
        recurrenceInterval: "Intervalo",
        timeUnits: {
          minute: "minuto(s)",
          hour: "hora(s)",
          day: "Dia(s)",
          week: "semana(s)",
          biweek: "quincena(s)",
          month: "mes(es)",
          year: "ano(s)"
        },
        filterByStatus: "Filtrar por Estado",
        filterByRecurrence: "Filtrar por Recurrencia",
        all: "Todos",
        recurring: "Recurrentes",
        single: "Unica",
        recurringCampaign: "Campana recurrente",
        executions: "ejecuciones",
        tagPrefix: "Tag",
        listRemoved: "Lista eliminada",
        whatsappRemoved: "WhatsApp eliminado",
        notDefined: "No definido",
        noSchedule: "Sin programacion",
        notCompleted: "No completada",
        loading: "Cargando...",
        noMessagesFound: "Ningun mensaje encontrado",
        enabled: "Habilitada",
        disabled: "Deshabilitada",
        stopCampaign: "Parar campana",
        restartCampaign: "Reiniciar campana",
        stopRecurrence: "Detener Recurrencia",
        stopRecurrenceMessage: "Seguro que deseas detener la recurrencia de esta campana! La campana actual continuara ejecutandose, pero no habra mas ejecuciones futuras.",
        report: "Reporte",
        edit: "Editar",
        delete: "Eliminar",
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campana",
        validContacts: "Contactos Validos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        scheduledDate: "Fecha programada",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusion",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Busqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Titulo",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Titulo",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta accion no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro eliminado",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila eliminada",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Estas seguro! Esta accion no se puede revertir! Los tickets en esa fila seguiran existiendo, pero ya no tendran ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualizacion",
          actions: "Acciones",
        },
        form: {
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          urlN8N: "URL N8N / Webhook",
          typebotSlug: "Slug de Typebot",
          typebotExpires: "Expira en (minutos)",
          typebotDelayMessage: "Delay mensaje (ms)",
          typebotKeywordFinish: "Palabra clave finalizar",
          typebotKeywordRestart: "Palabra clave reiniciar",
          typebotUnknownMessage: "Mensaje desconocido",
          typebotRestartMessage: "Mensaje reinicio",
          allowFlowbuilder: "Permitir FlowBuilder en paralelo",
          jsonContent: "Conteudo JSON"
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Estas seguro! Esta accion no se puede revertir! Se eliminaran las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la informacion del usuario se perdera. Los tickets abiertos de los usuarios se moveran a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campanas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          folderSize: " Tamano de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Ultima actualizacion",
          actions: "Acciones",
          money: "USD $",
          yes: "Sí",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurrencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
          generateInvoice: "Generar Factura",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          loadingError: "No se pudo cargar la lista de registros",
          success: "Operacion realizada con éxito!",
          error: "No fue posible realizar la operacion. Verifique si ya existe una empresa con el mismo nombre o si los campos fueron completados correctamente",
          deleted: "Empresa eliminada satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Registro",
          deleteMessage: "Realmente desea eliminar este registro!",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Filas",
          amount: "Valor",
          campaigns: "Difusiones",
          schedules: "Programas",
          trial: "Prueba",
          trialDays: "Dias de Prueba",
          public: "Publico",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "USD $",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Registro",
          deleteMessage: "Realmente desea eliminar este registro!",
        },
        toasts: {
          loadingError: "No se pudo cargar la lista de registros",
          success: "Operacion realizada con éxito!",
          error: "No fue posible realizar la operacion. Verifique si ya existe un plan con el mismo nombre o si los campos fueron completados correctamente",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Codigo del Video",
          description: "Descripcion",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Programas",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el dia",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Manana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este periodo.",
        confirmationModal: {
          deleteTitle: "Seguro que quieres eliminar este Programa!",
          deleteMessage: "Esta accion no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envio",
          assinar: "Firmar mensaje",
          reminderTitle: "Recordatorio (Opciónal)",
          reminderDescription:
            "Define una fecha de recordatorio. El mensaje se enviara en ese horario en lugar del horario original de la programacion.",
          reminderDate: "Fecha del recordatorio",
          reminderMessageInfo:
            "El mensaje del recordatorio sera el mismo del mensaje programado.",
          quickMessagePlaceholder: "Escriba para buscar respuestas rapidas...",
          noQuickMessagesFound: "No se encontraron respuestas rapidas",
          status: "Estado",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Seguro que quieres eliminar esta Tag!",
          deleteMessage: "Esta accion no se puede revertir.",
        },
        table: {
          id: "ID",
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto(s)",
        backToKanban: "VOLVER A KANBAN",
        confirmationModal: {
          deleteTitle: "Seguro que quieres eliminar esta Lane!",
          deleteMessage: "Esta accion no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estas seguro de borrar este listado!",
          deleteAllMessage: "Estas seguro de borrar todos los listado!",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
          schedules: "Horarios",
          whitelabel: "Personalizacion",
          finalization: "Finalizacion"
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            open: "Abierto",
            pending: "Pendiente",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programacion de Horario",
            queueManagement: "Gestion por Cola",
            companyManagement: "Gestion por Empresa",
            connectionManagement: "Gestion por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "Informar que no se aceptan llamadas por WhatsApp!",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posicion en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact:
              "Aceptar audios de todos los contactos!",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            transferredTicketStatus: "Estado del ticket al transferir con usuario",
            DirectTicketsToWallets:
              "Mover automaticamente al cliente a la cartera",
            showNotificationPending:
              "Mostrar notificacion para tickets pendientes",
            copyContactPrefixSection:
              "Configuración de sigla para copia de contactos",
            copyContactPrefix: "Sigla para Copia de Contactos",
            copyContactPrefixPlaceholder: "Ej: COPIA_"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posicion en la fila",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la politica de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje eliminado",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar numero de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
      },
      messagesList: {
        metaPolicy: "Tienes 24h para responder tras recibir un mensaje, de acuerdo con las políticas de Meta.",
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "Quieres dejar un mensaje de evaluacion para el cliente!",
          dialogClosingTitle: "Finalizando la atencion al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menu de evaluacion",
          notMessage: "No hay mensaje seleccionado",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Habilitar Integración",
            disableIntegration: "Deshabilitar Integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "Ups! Debes asignar una etiqueta antes de cerrar el ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Escribe un comentario interno o usa / para respuestas rápidas...",
        placeholderOpen:
          "Escribe un mensaje o usa / para respuestas rápidas...",
        placeholderClosed:
          "Vuelve a abrir o acepta este ticket para enviar un mensaje.",
        placeholderPending:
          "Mensaje interno (ticket en espera de aceptación)...",
        placeholder24hExpired:
          "Ventana de 24h vencida: envía una plantilla oficial primero",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privado",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "No del Ticket",
          queue: "Sector",
          connection: "Conexión",
          scheduledDate: "Fecha programada",
        },
      },
      ticketInfo: {
        quickMessages: "Respuestas rapidas",
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "Aceptar audios del contacto!",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observacion",
          placeholder: "Agregue aqui la informacion",
        },
        confirmationModal: {
          title: "Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderan.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          document: "Documento",
          contact: "Contacto",
          meet: "Videollamada Meet",
          emoji: "Emoji",
          comments: "Comentarios",
          signature: "Firma",
          triggerFlow: "Disparar Flujo",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Hablar Con",
        confirmationModal: {
          title: "Borrar mensaje!",
          message: "Esta accion no puede ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      financial: {
        title: "Facturas",
        attention: "Atención:",
        expiredMessage: "Su suscripcion ha caducado. Pongase en contacto con el soporte para regularizar su situacion.",
        table: {
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Filas",
          value: "Valor",
          dueDate: "Fecha Venc.",
          status: "Estado",
          actions: "Acción",
        },
        status: {
          paid: "Pagado",
          expired: "Vencido",
          open: "Abierto",
        },
        buttons: {
          pay: "PAGAR",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexion de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontro WhatsApp predeterminado. Verifique la pagina de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no esta inicializada. Verifique la pagina de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la pagina de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un numero de whatsapp valido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la pagina de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticacion. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la pagina de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creacion de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este numero.",
        ERR_NO_SETTING_FOUND:
          "No se encontro ninguna configuracion con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontro ningun contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontro ningun ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontro ningun usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontro WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya esta en uso, elija otro.",
        ERR_CAMPAIGN_CONFIRMATION_MESSAGE_REQUIRED:
          "Debes informar al menos un mensaje de confirmacion cuando la confirmacion este activada.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay mas de una fila.",
        ERR_OUT_OF_HOURS: "Fuera del horario de oficina!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Metodo:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID de la Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "la prueba del envio",
      },
      recurrenceSection: {
        title: "Recurrencia",
        description:
          "Puede optar por enviar el mensaje de forma recurrente y seleccionar el intervalo. Si es un mensaje unico, no cambie nada en esta seccion.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envio normal en Dias no laborables",
        sendOneBusinessDayBefore: "Enviar un Dia habil antes",
        sendOneBusinessDayLater: "Enviar un Dia habil despues",
        options: {
          days: "Días",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva Campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar Campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmision",
        whichPhraseTriggersTheFlow: " Que frase desencadena el flujo!",
        selectAConnection: "Seleccione una conexion",
        chooseAStream: "Elige una transmision",
        status: " Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPANA ",
        saveCampaign: "Guardar Campana",
        active: "Activo",
        disabled: "Deshabilitado",
        noConnection: "Ninguna conexion",
        nameNotDefined: "Nombre no definido",
        toastDeleted: "Campana eliminada con éxito",
        emptyTitle: "Ninguna campana encontrada",
        emptyHint:
          'Haz clic en "Nueva Campaña" para crear su primera campaña de flujo',
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID del Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Ultimo Mensaje",
          fullReport: "El informe completo esta adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontro usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta accion no se puede deshacer, confirmar!",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "Esta seguro de que desea eliminar este mensaje!",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminacion",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        forward: "Reenviar",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripcion del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "Esta seguro de que desea eliminar este grupo!",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Titulo",
        description: "Descripcion",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripcion del grupo.",
          name: "Nombre del Grupo",
          create: "Crear",
          edit: "Editar",
        },
      },
      flowBuilder: {
        title: "Editor de Flujos",
        addNodes: "Agregar nodos",
        noConditions: "Sin condiciones configuradas",
        startInfo: "Inicio del flujo",
        categories: {
          basics: "Basicos",
          content: "Contenido",
          interaction: "Interaccion",
          logic: "Logica",
          system: "Sistema",
          integrations: "Integraciones"
        },
        validation: {
          required: "Obligatorio"
        },
        deepseekModal: {
          title: "Configurar DeepSeek",
          basicSettings: "Configuración basica",
          addTitle: "Agregar DeepSeek al flujo",
          editTitle: "Editar DeepSeek del flujo",
          assistantName: "Nombre del Asistente",
          apiKey: "API Key DeepSeek",
          model: "Modelo DeepSeek",
          systemPrompt: "Prompt del Sistema",
          promptPlaceholder: "Describe como debe comportarse la IA, que informacion debe recopilar y como debe responder...",
          searchVariable: "Buscar variable...",
          temperature: "Temperatura",
          temperatureHelp: "0 = conservador, 2 = creativo",
          maxTokens: "Max Tokens",
          maxTokensHelp: "Tamano maximo de la respuesta",
          maxMessages: "Max Mensajes",
          maxMessagesHelp: "Historial de contexto",
          flowBehavior: "Comportamiento del Flujo",
          flowBehaviorTooltip: "Configura como debe comportarse DeepSeek en el flujo",
          operationMode: "Modo de Funcionamiento",
          permanent: "Permanente",
          permanentDesc: "Terminar el flujo aqui",
          permanentHelp: "El usuario conversa con la IA hasta pedir transferencia o finalizar.",
          temporary: "Temporal",
          temporaryDesc: "Volver al flujo despues",
          temporaryHelp: "La IA realiza una tarea y luego regresa al flujo normal.",
          maxInteractions: "Interacciones maximas",
          maxInteractionsHelp: "Maximo de mensajes antes de volver al flujo (0 = ilimitado).",
          completionTimeout: "Tiempo limite (minutos)",
          completionTimeoutHelp: "Tiempo limite antes de volver al flujo (0 = sin limite).",
          continueKeywords: "Palabras clave para continuar",
          keywordPlaceholder: "Escribe una palabra clave",
          addKeyword: "Agregar",
          continueKeywordsHelp: "Cuando el usuario envie una de estas palabras, el flujo continuara automaticamente.",
          objective: "Objetivo",
          objectivePlaceholder: "Describe el objetivo de la conversacion",
          objectiveHelp: "Describe que debe completar la IA (ej.: \"recopilar nombre, email y telefono\").",
          autoCompleteOnObjective: "Auto completar con objetivo",
          autoCompleteOnObjectiveHelp: "La IA evaluara si completo el objetivo y regresara al flujo.",
          skipResponseTitle: "Modo clasificador",
          skipResponseSubtitle: "No responder al cliente",
          skipResponseHelp: "La IA analiza el mensaje pero no envia respuesta. Util para auto-enrutamiento con un nodo Router despues.",
          skipResponse: "Omitir respuesta",
          temporarySettingsTitle: "Configuración del modo temporal",
          temporarySettingsDesc: "Define cuando la IA debe parar y regresar al flujo.",
          queueId: "ID de fila (transferencia)",
          queueIdHelp: "ID de la fila para transferir si el usuario pide un agente (0 = no transferir).",
          variables: "Variables disponibles",
          variablesDesc: "Use estas variables en sus prompts",
          save: "Agregar",
          update: "Guardar",
          cancel: "Cancelar"
        },
        nodes: {
          start: { name: "Inicio", desc: "Punto inicial del flujo" },
          content: { name: "Contenido", desc: "Enviar texto, imagen, audio o video" },
          text: { name: "Texto", desc: "Mensaje de texto simple" },
          img: { name: "Imagen", desc: "Enviar una imagen" },
          audio: { name: "Audio", desc: "Enviar un audio" },
          video: { name: "Video", desc: "Enviar un video" },
          document: { name: "Documento", desc: "Enviar un archivo/documento" },
          menu: { name: "Menu", desc: "Menu de opciones para el usuario" },
          input: { name: "Entrada", desc: "Recolectar entrada del usuario" },
          interval: { name: "Intervalo", desc: "Pausar ejecucion por tiempo" },
          randomizer: { name: "Aleatorizador", desc: "Eleccion aleatoria de caminos" },
          condition: { name: "Condicion", desc: "Ramificacion basada en condiciones" },
          router: { name: "Router", desc: "Multiples ramificaciones logicas" },
          queues: { name: "Filas", desc: "Gestionar filas de atencion" },
          tags: { name: "Etiquetas", desc: "Anadir etiquetas al contacto" },
          removeTag: { name: "Eliminar Etiqueta", desc: "Eliminar etiquetas del contacto" },
          switchFlow: { name: "Cambiar Flow", desc: "Dirigir a otro flujo" },
          attendant: { name: "Agente", desc: "Transferir a un agente" },
          kanban: { name: "Kanban", desc: "Mover a carril Kanban", selectLane: "Seleccione un carril Kanban", movingTo: "Mover a Kanban", editKanban: "Editar Kanban", chooseLane: "Elija el carril Kanban de destino", noLane: "Ningun carril seleccionado" },
          closeTicket: { name: "Cerrar Ticket", desc: "Cierra la atencion actual" },
          followup: { name: "Seguimientos", desc: "Programar secuencia de seguimientos" },
          advancedPause: { name: "Pausa Inteligente", desc: "Pausa con multiples salidas" },
          httpRequest: { name: "Petición HTTP", desc: "Petición HTTP externa" },
          variable: { name: "Variable", desc: "Definir variables globales" },
          gemini: { name: "Gemini", desc: "Integración con Gemini" },
          openai: { name: "OpenAI", desc: "Integración con OpenAI" },
          deepseek: { name: "DeepSeek", desc: "Integración con DeepSeek AI" },
          validation: {
            required: "Obligatorio"
          },
          deepseekModal: {
            title: "Configurar DeepSeek",
            basicSettings: "Configuración básica",
            addTitle: "Agregar DeepSeek al flujo",
            editTitle: "Editar DeepSeek del flujo",
            assistantName: "Nombre del Asistente",
            apiKey: "API Key DeepSeek",
            model: "Modelo DeepSeek",
            systemPrompt: "Prompt del Sistema",
            promptPlaceholder: "Describe cómo debe comportarse la IA, qué información debe recopilar y cómo debe responder...",
            searchVariable: "Buscar variable...",
            temperature: "Temperatura",
            temperatureHelp: "0 = conservador, 2 = creativo",
            maxTokens: "Max Tokens",
            maxTokensHelp: "Tamaño máximo de la respuesta",
            maxMessages: "Max Mensajes",
            maxMessagesHelp: "Historial de contexto",
            flowBehavior: "Comportamiento del Flujo",
            flowBehaviorTooltip: "Configura cómo debe comportarse DeepSeek en el flujo",
            operationMode: "Modo de Funcionamiento",
            permanent: "Permanente",
            permanentDesc: "Terminar el flujo aquí",
            permanentHelp: "El usuario conversa con la IA hasta pedir transferencia o finalizar.",
            temporary: "Temporal",
            temporaryDesc: "Volver al flujo después",
            temporaryHelp: "La IA realiza una tarea y luego regresa al flujo normal.",
            maxInteractions: "Interacciones máximas",
            maxInteractionsHelp: "Máximo de mensajes antes de volver al flujo (0 = ilimitado).",
            completionTimeout: "Tiempo límite (minutos)",
            completionTimeoutHelp: "Tiempo límite antes de volver al flujo (0 = sin límite).",
            continueKeywords: "Palabras clave para continuar",
            keywordPlaceholder: "Escribe una palabra clave",
            addKeyword: "Agregar",
            continueKeywordsHelp: "Cuando el usuario envíe una de estas palabras, el flujo continuará automáticamente.",
            objective: "Objetivo",
            objectivePlaceholder: "Describe el objetivo de la conversación",
            objectiveHelp: "Describe qué debe completar la IA (ej.: “recopilar nombre, email y teléfono”).",
            autoCompleteOnObjective: "Auto completar con objetivo",
            autoCompleteOnObjectiveHelp: "La IA evaluará si completó el objetivo y regresará al flujo.",
            skipResponseTitle: "Modo clasificador",
            skipResponseSubtitle: "No responder al cliente",
            skipResponseHelp: "La IA analiza el mensaje pero no envía respuesta. Útil para auto-enrutamiento con un nodo Router después.",
            skipResponse: "Omitir respuesta",
            temporarySettingsTitle: "Configuración del modo temporal",
            temporarySettingsDesc: "Define cuándo la IA debe parar y regresar al flujo.",
            queueId: "ID de fila (transferencia)",
            queueIdHelp: "ID de la fila para transferir si el usuario pide un agente (0 = no transferir).",
            variables: "Variables disponibles",
            variablesDesc: "Use estas variables en sus prompts",
            save: "Agregar",
            update: "Guardar",
            cancel: "Cancelar"
          },
          deepseek: {
            title: "Configurar DeepSeek",
            addTitle: "Agregar DeepSeek al flujo",
            editTitle: "Editar DeepSeek del flujo",
            validation: {
              required: "Obligatorio",
              tooShort: "Muy corto!",
              tooLong: "Muy largo!"
            },
            promptRequired: "Describe el entrenamiento para Inteligencia Artificial",
            invalidModel: "Modelo invalido",
            modelRequired: "Informe el modelo",
            minTokens: "Minimo 10 tokens",
            maxTokens: "Maximo 8000 tokens",
            maxTokens4k: "Maximo 4000 tokens",
            maxTokensRequired: "Informe el numero maximo de tokens",
            minTemp: "Minimo 0",
            maxTemp: "Maximo 2",
            tempRequired: "Informe la temperatura",
            apiKeyRequired: "Informe la API Key",
            voiceRequired: "Informe el modo para Voz",
            voiceKeyRequired: "Voice Key es obligatoria para sintesis de voz",
            voiceRegionRequired: "Voice Region es obligatoria para sintesis de voz",
            minMessages: "Minimo 1 mensaje",
            maxMessages: "Maximo 100 mensajes",
            maxMessagesRequired: "Informe el numero maximo de mensajes",
            invalidFlowMode: "Modo de flujo invalido",
            flowModeRequired: "Seleccione el modo de flujo",
            minInteractions: "Minimo 1 interaccion",
            maxInteractions: "Maximo 50 interacciones",
            minTimeout: "Minimo 1 minuto",
            maxTimeout: "Maximo 60 minutos",
            keywordEmpty: "La palabra clave no puede estar vacia",
            keywordRequired: "Al menos una palabra clave es obligatoria en el modo temporario",
            objectiveRequired: "El objetivo es obligatorio cuando auto completar esta activo"
          },
          maxInteractions: "Interacciones Maximas",
          completionTimeout: "Tiempo limite (minutos)",
          objective: "Objetivo de la IA",
          queueId: "ID de Fila (para transferencia)",
          openai: {
            title: "Configurar OpenAI",
            addTitle: "Agregar OpenAI al flujo",
            editTitle: "Editar OpenAI del flujo",
            assistantName: "Nombre del Asistente",
            apiKey: "API Key OpenAI",
            model: "Modelo OpenAI",
            systemPrompt: "Prompt del Sistema",
            promptPlaceholder: "Describe como debe comportarse la IA, que informacion debe recopilar, como debe responder...",
            temperature: "Temperatura",
            temperatureHelp: "0 = conservador, 2 = creativo",
            maxTokens: "Max Tokens",
            maxTokensHelp: "Tamano maximo de la respuesta",
            maxMessages: "Max Mensajes",
            maxMessagesHelp: "Historial de contexto",
            responseType: "Tipo de Respuesta",
            voiceKey: "Voice Key (Azure)",
            voiceRegion: "Voice Region (Azure)",
            flowBehavior: "Comportamiento del Flujo",
            flowBehaviorTooltip: "Configura como debe comportarse OpenAI en el flujo",
            operationMode: "Modo de Funcionamiento",
            permanent: "Permanente",
            permanentDesc: "Terminar flujo aqui",
            temporary: "Temporario",
            temporaryDesc: "Modo de conversacion",
            maxInteractions: "Interacciones Maximas",
            completionTimeout: "Tiempo limite (minutos)",
            continueKeywords: "Palabras clave para continuar",
            keywordPlaceholder: "Escribe una palabra clave",
            objective: "Objetivo",
            objectivePlaceholder: "Describe el objetivo de la conversacion",
            autoCompleteOnObjective: "Auto completar con objetivo",
            skipResponse: "Omitir respuesta",
            variables: "Variables disponibles",
            variablesDesc: "Use estas variables en sus prompts",
            save: "Agregar",
            update: "Guardar",
            cancel: "Cancelar",
            promptRequired: "Describe el entrenamiento para Inteligencia Artificial",
            invalidModel: "Modelo invalido",
            modelRequired: "Informe el modelo",
            minTokens: "Minimo 10 tokens",
            maxTokens: "Maximo 8000 tokens",
            maxTokensRequired: "Informe el numero maximo de tokens",
            minTemp: "Minimo 0",
            maxTemp: "Maximo 2",
            tempRequired: "Informe la temperatura",
            apiKeyRequired: "Informe la API Key",
            voiceKeyRequired: "Voice Key es obligatoria para sintesis de voz",
            voiceRegionRequired: "Voice Region es obligatoria para sintesis de voz",
            minMessages: "Minimo 1 mensaje",
            maxMessages: "Maximo 100 mensajes",
            maxMessagesRequired: "Informe el numero maximo de mensajes",
            invalidFlowMode: "Modo de flujo invalido",
            flowModeRequired: "Seleccione el modo de flujo",
            minInteractions: "Minimo 1 interaccion",
            maxInteractions: "Maximo 50 interacciones",
            minTimeout: "Minimo 1 minuto",
            maxTimeout: "Maximo 60 minutos",
            keywordEmpty: "La palabra clave no puede estar vacia",
            keywordRequired: "Al menos una palabra clave es obligatoria en el modo temporario",
            objectiveRequired: "El objetivo es obligatorio cuando auto completar esta activo"
          },
          gemini: {
            title: "Configurar Gemini",
            addTitle: "Agregar Gemini al flujo",
            editTitle: "Editar Gemini del flujo"
          },
          pause: {
            title: "Configurar Pausa Inteligente",
            value: "Valor",
            unit: "Unidad",
            outOfHours: "Habilitar salida 'Fuera de Horario'",
            seconds: "Segundos",
            minutes: "Minutos",
            hours: "Horas",
            days: "Días"
          },
          phrase: {
            campaignName: "Nombre de la Campana",
            selectFlow: "Seleccione un flujo",
            whatsappConnections: "Conexiones WhatsApp",
            type: "Tipo",
            flowNotFound: "Flujo no encontrado",
            campaignUpdated: "Campana actualizada con éxito!",
            campaignCreated: "Campana creada con éxito!",
            fillRequired: "Por favor, complete todos los campos obligatorios",
            loadFlowsError: "Error al cargar flujos",
            loadConnectionsError: "Error al cargar conexiones",
            loadDataError: "Error al cargar datos de la Campana",
            saveError: "Error al guardar Campana"
          },
          chatbot: {
            deleteQueueConfirm: "Estas seguro! Todas las opciones internas tambien seran eliminadas",
            botSaved: "Bot guardado con éxito"
          },
          settings: {
            salesValueAtClose: "Informar valor de la venta al finalizar atencion",
            reasonName: "Nombre del Motivo",
            descriptionOptional: "Descripcion (opcional)",
            reasonRequired: "El nombre del motivo es obligatorio",
            reasonUpdated: "Motivo actualizado con éxito!",
            reasonCreated: "Motivo creado con éxito!",
            reasonDeleted: "Motivo eliminado con éxito!",
            saveError: "Error al guardar motivo",
            deleteError: "Error al eliminar motivo",
            configUpdated: "Configuración actualizada con éxito!",
            configError: "Error al actualizar configuracion",
            addReason: "Agregar Motivo",
            editReason: "Editar Motivo",
            noReason: "Ningun motivo registrado. Haga clic en",
            noReasonEnd: "para agregar",
            facebookAppId: "Facebook App ID",
            facebookAppSecret: "Facebook App Secret",
            facebookVerifyToken: "Facebook Verify Token",
            facebookApiVersion: "Version de API de Facebook",
            instagramAppId: "Instagram App ID",
            instagramAppSecret: "Instagram App Secret",
            instagramVerifyToken: "Instagram Verify Token",
            pixCert: "Certificado Efi - API PIX (p12)",
            gemini: {
              title: "Configurar Gemini",
              addTitle: "Agregar Gemini al flujo",
              editTitle: "Editar Gemini del flujo",
              assistantName: "Nombre del Asistente",
              apiKey: "API Key Google AI",
              model: "Modelo Gemini",
              systemPrompt: "Prompt del Sistema",
              temperature: "Temperatura",
              maxTokens: "Max Tokens",
              maxMessages: "Max Mensajes",
              maxInteractions: "Interacciones Maximas",
              completionTimeout: "Tiempo limite (minutos)",
              objective: "Objetivo de la IA",
              queueId: "ID de Fila (para transferencia)"
            },
            audio: {
              saved: "Audio guardado con éxito!"
            },
            image: {
              saved: "Imagen guardada con éxito!"
            },
            video: {
              saved: "Video guardado con éxito!"
            },
            document: {
              saved: "Documento guardado con éxito!"
            },
            media: {
              fileTooBig5MB: "Archivo muy grande! Maximo 5MB",
              fileTooBig2MB: "Archivo muy grande! Maximo 2MB",
              fileTooBig20MB: "Archivo muy grande! Maximo 20MB",
              fileTooBig15MB: "Archivo muy grande! Maximo 15MB",
              fileTooBig10MB: "Archivo muy grande! Maximo 10MB",
              emptyFields: "Campos de mensaje vacios!",
              invalidInterval: "El intervalo no puede ser 0 ni mayor a 120!",
              deleteEmptyCards: "Eliminar los cards vacios (Imagen, Audio y Video)",
              contentAdded: "Contenido agregado con éxito!"
            }
          },
          companies: {
            nameRequired: "El nombre es obligatorio",
            emailInvalid: "El email es invalido",
            emailRequired: "El email es obligatorio",
            prompt: {
              nameRequired: "El nombre es obligatorio (minimo 5 caracteres)",
              nameTooShort: "Muy corto!",
              nameTooLong: "Muy largo!",
              promptRequired: "Describe el entrenamiento para Inteligencia Artificial",
              voiceRequired: "Informe el modo para Voz",
              maxTokensRequired: "Informe el numero maximo de tokens",
              temperatureRequired: "Informe la temperatura",
              apiKeyRequired: "Informe la API Key",
              queueRequired: "Informe la fila",
              maxMessagesRequired: "Informe el numero maximo de mensajes"
            },
            input: {
              questionLabel: "Digite la pregunta",
              variableName: "Nombre de la variable"
            }
          }
        },
        routerNode: {
          title: "Router Logico",
          description: "Es un selector multiple. Puedes crear varios caminos (ej: 'Ventas', 'Precios') en un solo nodo.",
          howItWorks: "1. El bot revisa la Condicion 1.\n2. Si es verdad, sigue ese camino.\n3. Si no, revisa la Condicion 2...\n4. Si NADA coincide, usa el camino rojo (Por defecto).",
          defaultPath: "Por defecto (Falso)",
          defaultDesc: "Si ninguna condicion coincide",
          addCondition: "Doble clic para gestionar",
          condition: "Condicion"
        },
        conditionNode: {
          title: "Condicion Logica",
          howToUse: "1. Selecciona una variable (ej: ultimaMensaje o aiResponse).\n2. Elige un operador (ej: contiene o igual).\n3. Define el valor esperado.\n\nSi la regla se cumple, el flujo seguira por el camino Verde.\nSi no, por el camino Rojo.",
          true: "VERDADERO",
          false: "FALSO",
          value1: "Valor 1",
          value2: "Valor 2",
          operators: {
            equals: "Igual a",
            notEquals: "Diferente de",
            contains: "Contiene",
            startsWith: "Comienza con",
            endsWith: "Termina con",
            greaterThan: "Mayor que",
            lessThan: "Menor que",
            greaterOrEqual: "Mayor o igual a",
            lessOrEqual: "Menor o igual a",
            isEmpty: "Esta vacio",
            isNotEmpty: "No esta vacio",
          }
        },
        followup: {
          configure: "Configurar FollowUp",
          description: "Elige que secuencia de FollowUp (Floup) se activara cuando el flujo llegue aqui.",
          select: "Seleccionar FollowUp",
          notConfigured: "No configurado",
        },
        active: "Activo",
        inactive: "Inactivo",
        flowDeleted: "Flujo eliminado con éxito",
        flowDuplicated: "Flujo duplicado con éxito",
        selectZipFile: "Por favor, selecciona un archivo ZIP (.zip)",
        searchFlows: "Buscar flujos...",
        newFlow: "Nuevo Flujo",
        createFlow: "Crear flujo",
        confirmDelete: "Eliminar flujo",
        deleteWarning: "Esta accion no se puede deshacer. Todas las integraciones relacionadas se perderan.",
        confirmDuplicate: "Duplicar flujo",
        duplicateInfo: "Se creara una copia del flujo para que puedas editarla."
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicacion",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",
        successMessage: "Operacion actualizada con éxito",
        loadingSettings: "Cargando configuraciones...",

        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la informacion basica de la aplicacion",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imagenes",
          logosDescription: "Sube los logos e imagenes de fondo de la aplicacion",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona que idiomas estaran disponibles en el sistema"
        },
        colorPicker: {
          title: "Selecciona un color",
          cancel: "Cancelar",
          ok: "Aceptar"
        }
      },
    },
    kanbanAutomation: {
      title: "Automatizaciones Kanban",
      miniManual: "Mini manual",
      hide: "Ocultar",
      show: "Mostrar",
      add: "Agregar",
      close: "Cerrar",
      refresh: "Refrescar",
      loadingExecutions: "Cargando ejecuciones...",
      viewExecutions: "Ver ejecuciones",
      newRule: "Nueva regla",
      save: "Guardar",
      yes: "Sí",
      no: "No",
      edit: "Editar",
      delete: "Eliminar",
      form: {
        name: "Nombre",
        event: "Evento",
        stage: "Etapa",
        anyStage: "Cualquier etapa",
        description: "Descripción",
        delayHours: "Horas (delay)",
        specificTime: "Hora específica",
        hour: "Hora",
        minute: "Minuto",
        active: "Activa",
        once: "Una vez",
        value: "Valor",
        productPlaceholder: "Ej: Curso Premium"
      },
      manual: {
        missingTranslation: "No hay mini manual traducido para este idioma. Cambia el idioma a Español/Portugués/English.",
        item1: "1. <strong>Nombre</strong>: escribe un nombre claro para reconocer la regla. Ejemplo: <strong>Producto X - seguimiento</strong>.",
        item2: "2. <strong>Evento</strong>: define cuándo se dispara. <strong>Al entrar a etapa</strong>: apenas toca la columna. <strong>Después de X horas en etapa</strong>: espera dentro de esa columna. <strong>Después de X horas desde última conversación</strong>: espera silencio del cliente (se reinicia si escribe). <strong>A una hora específica</strong>: dispara a la hora indicada si sigue en la etapa.",
        item3: "3. <strong>Etapa</strong>: elige la columna donde aplica la regla. Si la dejas vacía, puede aplicar en cualquier etapa.",
        item4: "4. <strong>Horas</strong>: el número que reemplaza la “X”. Ej: <strong>2</strong> = 2 h después de entrar a la etapa; <strong>6</strong> = 6 h de silencio desde la última conversación.",
        item5: "5. <strong>Hora específica</strong>: solo para el evento por horario. Ej: <strong>18:30</strong>.",
        item6: "6. <strong>Una vez</strong>: si lo activas, la regla no se ejecuta varias veces sobre el mismo ticket.",
        item7: "7. <strong>Condiciones</strong>: sirven para filtrar.",
        item7a: "- <strong>Producto + Igual a + Curso Premium</strong>: solo para ese producto.",
        item7b: "- <strong>Tag del ticket + Tiene + producto-premium</strong>: solo si el ticket tiene esa tag.",
        item7c: "- <strong>Campo custom del contacto</strong>: usa <strong>Campo</strong> con el nombre exacto.",
        item7d: "- <strong>Fecha inicio ticket + Mayor o igual que + 2026-03-01</strong>: tickets desde esa fecha.",
        item7e: "- <strong>Fecha última conversación + Antes de + 2026-03-10</strong>: detecta inactividad.",
        item8: "8. <strong>Acciones</strong>: puedes disparar FlowBuilder, agregar/quitar tags o mover de etapa.",
        item8a: "8.1 <strong>Tag</strong> agrega/quita etiquetas normales del ticket.",
        item8b: "8.2 <strong>Payload</strong> es avanzado; déjalo vacío normalmente.",
        item9: "9. <strong>Prueba recomendada</strong>: crea una regla con <strong>Al entrar a etapa</strong>, sin condiciones, y una acción de <strong>Disparar FlowBuilder</strong>; mueve un ticket y mira <strong>Últimas ejecuciones</strong>.",
        item10: "10. <strong>Uso por producto</strong>: una condición <strong>Producto = nombre exacto</strong> y listo.",
        item11: "11. <strong>Importante</strong>: si el ticket ya estaba en la etapa, usa <strong>Hora específica</strong> o <strong>Después de X horas en etapa</strong>.",
        item12: "12. <strong>Vaciar una etapa</strong>: crea regla <strong>Hora específica</strong> sin condiciones y acción <strong>Mover a etapa</strong> destino.",
        item13: "13. <strong>Seguimiento por silencio</strong>: evento <strong>Después de X horas desde última conversación</strong> + horas + acción. Si el cliente escribe, se reinicia.",
        item14: "14. <strong>Horario protegido</strong>: ventana 08:00-21:00; fuera de rango se mueve al siguiente horario válido.",
        item15: "15. <strong>Espaciado humano</strong>: si varios tickets coinciden en hora, se separan 20 s para evitar ráfagas."
      },
      rules: {
        title: "Reglas"
      },
      sections: {
        conditions: "Condiciones",
        actions: "Acciones"
      },
      noConditions: "Sin condiciones (aplica a todos).",
      table: {
        name: "Nombre",
        event: "Evento",
        stage: "Etapa",
        active: "Activa",
        actions: "Acciones",
        executionType: "Tipo de ejecución",
        fireTime: "Hora de disparo"
      },
      modal: {
        executionsTitle: "Ejecuciones"
      },
      executions: {
        title: "Últimas ejecuciones",
        date: "Fecha",
        rule: "Regla",
        ticket: "Ticket",
        event: "Evento",
        status: "Estado"
      }
    },
    wallets: {
      wallet: "Cartera"
    },
    callHistoricals: {
      cards: {
        total: "Total de llamadas",
        rejected: "Llamadas rechazadas",
        answered: "Llamadas atendidas",
        finished: "Llamadas finalizadas"
      },
      noRecords: "Ningún registro encontrado",
      na: "N/A",
      direction: {
        incoming: "Llamada recibida",
      },
      status: {
        ended: "Finalizada",
        active: "Activa",
        ringing: "Sonando",
        busy: "Ocupada",
        noAnswer: "No atendida",
        rejected: "Rechazada",
      },
    },
    birthdaySettings: {
      title: "Cumpleaños",
      loading: "Cargando configuración...",
      previewLabel: "Previsualización:",
      sections: {
        user: "Cumpleaños de usuarios",
        contact: "Cumpleaños de contactos",
        general: "Configuración general",
      },
      switches: {
        userEnabled: "Habilitar cumpleaños de usuarios",
        createAnnouncement:
          "Crear informativo interno para cumpleaños de usuarios",
        contactEnabled:
          "Habilitar envío automático de mensajes de cumpleaños para contactos",
      },
      fields: {
        userMessage: "Mensaje de cumpleaños para usuarios",
        contactMessage: "Mensaje de cumpleaños para contactos",
        sendTime: "Hora de envío de los mensajes",
        whatsappConnection: "Conexión WhatsApp para envío",
      },
      helpers: {
        userEnabled:
          "Cuando está habilitado, se mostrará un modal y se podrá crear un informativo interno.",
        createAnnouncement:
          "Crea un informativo interno que se muestra para todos los usuarios de la empresa.",
        userMessage: "Usa {nome} para incluir el nombre del usuario.",
        contactEnabled:
          "Envía automáticamente un mensaje de cumpleaños por WhatsApp a los contactos aniversariantes.",
        contactMessage:
          "Usa {nome} para incluir el nombre del contacto y {idade} para la edad.",
        sendTime: "Hora en que los mensajes automáticos serán enviados.",
        whatsappConnection:
          "Conexión WhatsApp que se usará para enviar mensajes de cumpleaños.",
      },
      variables: {
        title: "Variables disponibles en los mensajes:",
        tokens: {
          name: "{nome}",
          age: "{idade}",
        },
        labels: {
          name: "Nombre de la persona",
          age: "Edad de la persona (solo para contactos)",
        },
      },
      placeholders: {
        selectConnection: "Seleccione una conexión",
      },
      buttons: {
        save: "Guardar configuración",
        saving: "Guardando...",
        testMessage: "Probar mensaje",
      },
      prompts: {
        contactId: "Ingrese el ID de un contacto para probar:",
      },
      toasts: {
        loadError: "Error al cargar la configuración de cumpleaños",
        saveSuccess: "¡Configuración de cumpleaños guardada con éxito!",
        saveError: "Error al guardar la configuración",
        testSent: "¡Mensaje de prueba enviado!",
        testError: "Error al enviar mensaje de prueba",
      },
    },
    messagesApi: {
      title: "API externa - Documentación completa"
    },
},
};

export { messages };
